<template>
  <div>
    <div class="gf-project-tabs row">
      <div class="col mb-3">
        <h6>Отображается</h6>
        <div
          id="visibleTabsGroup"
          ref="visibleTabsGroup"
          class="gf-project-tabs__list"
        >
          <div
            v-for="tab in visibleTabs"
            :key="tab.name"
            class="d-flex align-items-center gf-project-tabs__list-tab"
            :class="{ '--block-tab-pull': !tab.canBeHidden }"
            :data-id="tab.name"
          >
            <i
              class="mr-1"
              :class="tab.icon"
            />
            <span class="mr-2">{{ tab.title }}</span>
            <i
              v-if="!tab.canBeHidden"
              class="gf-icon gf-icon-eye mr-3 text-muted"
            ></i>
            <i class="gf-icon gf-icon-sliders ml-auto" />
          </div>
        </div>
      </div>
      <div class="col mb-3">
        <h6>Скрыто</h6>
        <div
          id="hiddenTabsGroup"
          ref="hiddenTabsGroup"
          class="gf-project-tabs__list"
        >
          <div
            v-for="tab in hiddenTabs"
            :key="tab.name"
            class="d-flex align-items-center gf-project-tabs__list-tab"
            :data-id="tab.name"
          >
            <i
              class="mr-1"
              :class="tab.icon"
            />
            <span class="mr-3">{{ tab.title }}</span>
            <i class="gf-icon gf-icon-grip-lines ml-auto" />
          </div>
        </div>
      </div>
    </div>
    <div class="float-right">
      <button
        ref="resetButton"
        type="button"
        class="btn btn-dark btn-sm mr-2"
        @click="resetProjectTabs"
      >
        Сбросить
      </button>
      <button
        ref="saveButton"
        type="submit"
        class="btn btn-primary btn-sm"
        @click="saveProjectTabs"
      >
        Сохранить
      </button>
    </div>
  </div>
</template>

<script>
import repositoryService from '../../services/repository.service';

export default {
  // eslint-disable-next-line vue/match-component-file-name
  name: 'GfProjectTabEdit',
  props: {
    projectAlias: {
      type: String,
      default: null,
      required: true
    },
    userAlias: {
      type: String,
      default: null,
      required: true
    }
  },
  data() {
    return {
      visibleSortableList: null,
      visibleTabs: [],
      hiddenTabs: [],
      SortableClass: null
    };
  },
  mounted() {
    repositoryService.getProjectTabs(this.userAlias, this.projectAlias).then((res) => {
      this.visibleTabs = new Array(res.tabs.length);
      this.fillTabsArrays(res.tabs);
      this.visibleTabs = this.visibleTabs.filter((element) => element !== null);
      this.createSortableLists();
    });
  },
  methods: {
    createSortableLists() {
      import('sortablejs')
        .then((component) => {
          this.SortableClass = component.default;
          this.visibleSortableList = new this.SortableClass(this.$refs.visibleTabsGroup, {
            group: {
              name: 'shared'
            },
            animation: 100,
            ghostClass: 'dropped-element',
            // eslint-disable-next-line consistent-return
            onMove(evt) {
              if (
                evt.to.id === 'hiddenTabsGroup' &&
                evt.dragged.classList.contains('--block-tab-pull')
              ) {
                return false;
              }
            }
          });

          // eslint-disable-next-line no-new
          new this.SortableClass(this.$refs.hiddenTabsGroup, {
            group: 'shared',
            animation: 100,
            ghostClass: 'dropped-element',
            sort: false
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    saveProjectTabs() {
      repositoryService
        .editProjectTabs(this.userAlias, this.projectAlias, this.visibleSortableList.toArray())
        .then(() => {
          this.$refs.saveButton.classList.add('disabled');
          window.location.reload();
        });
    },
    createTabObject(title, name, icon, canBeHidden) {
      const tab = {};
      tab.title = title;
      tab.name = name;
      tab.icon = icon;
      tab.canBeHidden = canBeHidden;
      return tab;
    },
    resetProjectTabs() {
      repositoryService.resetProjectTabs(this.userAlias, this.projectAlias).then(() => {
        this.$refs.resetButton.classList.add('disabled');
        window.location.reload();
      });
    },
    fillTabsArrays(tabsNames) {
      let tab = {};
      tab = this.createTabObject('Файлы', 'FILES_TAB', ' gf-icon gf-icon-file', false);
      tabsNames.includes('FILES_TAB')
        ? (this.visibleTabs[tabsNames.indexOf('FILES_TAB')] = tab)
        : this.hiddenTabs.push(tab);

      tab = this.createTabObject('Проблемы', 'ISSUES_TAB', 'gf-icon gf-icon-alert', true);
      tabsNames.includes('ISSUES_TAB')
        ? (this.visibleTabs[tabsNames.indexOf('ISSUES_TAB')] = tab)
        : this.hiddenTabs.push(tab);

      tab = this.createTabObject(
        'Запросы на слияние',
        'MERGE_REQUESTS_TAB',
        'gf-icon gf-icon-exchange',
        true
      );
      tabsNames.includes('MERGE_REQUESTS_TAB')
        ? (this.visibleTabs[tabsNames.indexOf('MERGE_REQUESTS_TAB')] = tab)
        : this.hiddenTabs.push(tab);

      tab = this.createTabObject('CI/CD', 'CI_CD_TAB', 'gf-icon gf-icon-rocket', true);
      tabsNames.includes('CI_CD_TAB')
        ? (this.visibleTabs[tabsNames.indexOf('CI_CD_TAB')] = tab)
        : this.hiddenTabs.push(tab);

      tab = this.createTabObject('Окружения', 'ENVIRONMENTS_TAB', 'gf-icon gf-icon-cloud', true);
      tabsNames.includes('ENVIRONMENTS_TAB')
          ? (this.visibleTabs[tabsNames.indexOf('ENVIRONMENTS_TAB')] = tab)
          : this.hiddenTabs.push(tab);

      tab = this.createTabObject('Коммиты', 'COMMITS_TAB', ' gf-icon gf-icon-dot', false);
      tabsNames.includes('COMMITS_TAB')
        ? (this.visibleTabs[tabsNames.indexOf('COMMITS_TAB')] = tab)
        : this.hiddenTabs.push(tab);

      tab = this.createTabObject('Ветки', 'BRANCH_TAB', 'gf-icon gf-icon-git-branch', false);
      tabsNames.includes('BRANCH_TAB')
        ? (this.visibleTabs[tabsNames.indexOf('BRANCH_TAB')] = tab)
        : this.hiddenTabs.push(tab);

      tab = this.createTabObject('Теги', 'TAGS_TAB', 'gf-icon gf-icon-tag', false);
      tabsNames.includes('TAGS_TAB')
        ? (this.visibleTabs[tabsNames.indexOf('TAGS_TAB')] = tab)
        : this.hiddenTabs.push(tab);

      tab = this.createTabObject('Релизы', 'RELEASES_TAB', 'gf-icon gf-icon-archive', true);
      tabsNames.includes('RELEASES_TAB')
        ? (this.visibleTabs[tabsNames.indexOf('RELEASES_TAB')] = tab)
        : this.hiddenTabs.push(tab);

      tab = this.createTabObject(
        'Реестр пакетов',
        'PACKAGE_REGISTRY_TAB',
        'gf-icon gf-icon-cube',
        true
      );
      tabsNames.includes('PACKAGE_REGISTRY_TAB')
        ? (this.visibleTabs[tabsNames.indexOf('PACKAGE_REGISTRY_TAB')] = tab)
        : this.hiddenTabs.push(tab);

      tab = this.createTabObject('Вики', 'WIKI_TAB', 'gf-icon gf-icon-book-open', true);
      tabsNames.includes('WIKI_TAB')
        ? (this.visibleTabs[tabsNames.indexOf('WIKI_TAB')] = tab)
        : this.hiddenTabs.push(tab);

      tab = this.createTabObject(
        'Статистика',
        'STATISTICS_TAB',
        'gf-icon gf-icon-chart-line',
        true
      );
      tabsNames.includes('STATISTICS_TAB')
        ? (this.visibleTabs[tabsNames.indexOf('STATISTICS_TAB')] = tab)
        : this.hiddenTabs.push(tab);

      tab = this.createTabObject('Настройки', 'SETTINGS_TAB', 'gf-icon gf-icon-gear', false);
      tabsNames.includes('SETTINGS_TAB')
        ? (this.visibleTabs[tabsNames.indexOf('SETTINGS_TAB')] = tab)
        : this.hiddenTabs.push(tab);
    }
  }
};
</script>

<style lang="scss">
.gf-project-tabs {
  $this: '.gf-project-tabs';

  @media (max-width: 575px) {
    flex-direction: column;
  }

  #{$this}__list {
    height: calc(100% - 26px);
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 16px;
    background-color: var(--light);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
  }

  #{$this}__list-tab {
    display: flex;
    align-items: center;
    padding: 4px 12px;
    text-decoration: none;
    font-size: 14px;
    border-radius: var(--border-radius);
    background-color: var(--bg-light);
    white-space: nowrap;

    &:hover {
      background: var(--bg-light);
      cursor: move;
    }
  }
  .dropped-element {
    background-color: var(--bg-light-selected);
  }
}
</style>
